import React from "react";

const SuccessScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f5f7fa] to-[#c3cfe2] p-5">
      <div className="bg-white rounded-2xl p-10 max-w-md w-full text-center shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
        {/* Animated Checkmark */}
        <div className="relative inline-block my-8">
          {/* Outer rings */}
          <div className="absolute top-1/2 left-1/2 w-40 h-40 bg-emerald-500/10 rounded-full animate-pulse-slow -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-emerald-500/15 rounded-full animate-pulse-slow-delay -translate-x-1/2 -translate-y-1/2" />

          {/* Main circle */}
          <div className="relative z-10 w-24 h-24 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center shadow-[0_10px_30px_rgba(16,185,129,0.3)] animate-scale-in">
            <div className="relative w-12 h-12 animate-checkmark-draw">
              <span className="absolute block w-[15px] h-[30px] border-r-[3px] border-b-[3px] border-white rotate-45 top-[5px] left-[16px]" />
            </div>
          </div>
        </div>

        {/* Text content */}
        <h1 className="text-2xl font-semibold text-gray-800 mt-5 mb-3">
          Successfully Reverified
        </h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          Your business has been now successfully verified with EmaraTax.
        </p>

        {/* <button className="bg-gradient-to-br from-emerald-500 to-emerald-600 text-white px-10 py-3 rounded-lg font-medium text-base shadow-[0_4px_15px_rgba(16,185,129,0.3)] transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(16,185,129,0.4)] active:translate-y-0">
          Continue
        </button> */}
      </div>
    </div>
  );
};

export default SuccessScreen;
